import singleCardEdit from '@/entities/insights/modal/edit-reference/single-card-edit/single-card-edit.vue';
import { GOOGLE_CONFIG, UPLOAD_FILE_SUPPORT } from '@/shared/constants/ds-constants';
import { documentCard } from '@/shared/model/document-card.model';
import { getExtensionFileByName } from '@/util/ds-util';
import vueCustomScrollbar from 'vue-custom-scrollbar';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import OneDrive from '../../../../../../content/lib/onedrive/OneDrive';

let tokenClient;
let access_token = null;

@Component({
  name: 'report-document',
  components: {
    vueCustomScrollbar: vueCustomScrollbar,
    'single-card': singleCardEdit,
  },
})
export default class reportDocument extends Vue {
  @Prop(Boolean) readonly fullScreenMode: false | any;
  scrollSettings = {
    wheelPropagation: false,
  };
  isShowSpinner = false;
  acceptUploadFile = UPLOAD_FILE_SUPPORT.join(', ');
  public uploadQueueFiles = [];
  lstFileToLarge = [];

  totalSelected = 0;
  selectedItems = [];
  checked = false;
  totalLoadingFile = 0;

  @Watch('selectedItems')
  watchSelectedItems() {
    this.totalSelected = this.selectedItems.length;
  }

  beforeCreate() {
    function gapiInit() {
      // @ts-ignore
      gapi.client.init({
        apiKey: GOOGLE_CONFIG.API_KEY,
        discoveryDocs: [GOOGLE_CONFIG.DISCOVERY_DOCS],
      });
    }
    // @ts-ignore
    gapi.load('client', gapiInit);
    // @ts-ignore
    gapi.load('picker', () => {}); // load google picker
    // @ts-ignore
    tokenClient = google.accounts.oauth2.initTokenClient({
      client_id: GOOGLE_CONFIG.CLIENT_ID,
      scope: GOOGLE_CONFIG.SCOPES,
      callback: '', // defined later
    });
  }

  public openChooseFile() {
    const fileUpload = document.getElementById('fileUpload') as HTMLInputElement;
    fileUpload.click();
  }

  public async uploadFromPC(files) {
    if (!this.uploadQueueFiles) {
      this.uploadQueueFiles = [];
    }
    this.lstFileToLarge = [];
    const array = this.uploadQueueFiles.filter(file => file.document && file.document === 'local');
    let i = array.length > 0 ? Math.max(...array.map(file => file.id)) : -1;
    for (const file of files) {
      if (this.isValidFileSize(file)) {
        if (this.validateFile(file.name)) {
          if (!this.uploadQueueFiles.filter(item => item.document && item.document === 'local').some(item => item.name === file.name)) {
            i++;
            const obj = await this.convertToDocumentCard(file, 'My PC', i);
            this.uploadQueueFiles.push(obj);
            this.selectedItems.push(obj);
          }
        }
      } else {
        this.lstFileToLarge.push(file.name);
      }
    }
    if (this.lstFileToLarge.length > 0) {
      this.noticeFileSizeToLarge();
    }
  }

  public isValidFileSize(file) {
    const size = file.size || file.sizeBytes;
    return size / 1024 / 1024 < 50; // restrict file less than 50MB
  }

  public validateFile(name): boolean {
    if (!name) {
      return false;
    }
    const extensionFile = getExtensionFileByName(name);
    return UPLOAD_FILE_SUPPORT.indexOf('.'.concat(extensionFile)) !== -1;
  }

  public noticeFileSizeToLarge() {
    this.$bvModal
      .msgBoxOk(`Upload files must be less than 50MB: ${this.lstFileToLarge.toString()}`, {
        title: 'Invalid File Size',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'primary',
        headerClass: 'p-2 border-bottom-0',
        footerClass: 'p-2 mt-0 border-top-0',
        centered: true,
        headerTextVariant: 'danger',
      })
      .then(value => {})
      .catch(err => {});
  }

  public googleSignin() {
    tokenClient.callback = async resp => {
      if (resp.error !== undefined) {
        throw resp;
      }
      access_token = resp.access_token;
      // await this.getFilesFromDrive();
      await this.createPicker(); // create google picker
    };

    if (access_token === null) {
      // Prompt the user to select a Google Account and ask for consent to share their data
      // when establishing a new session.
      tokenClient.requestAccessToken({ prompt: 'consent' });
    } else {
      // Skip display of account chooser and consent dialog for an existing session.
      tokenClient.requestAccessToken({ prompt: '' });
    }
  }

  public createPicker() {
    // @ts-ignore
    const view = new google.picker.DocsView(google.picker.ViewId.DOCS);
    view.setMimeTypes(GOOGLE_CONFIG.MIME_TYPES_SUPPORT); // limit file format
    // view.setOwnedByMe(true); // only owner file (not contain share with me)
    // @ts-ignore
    const picker = new google.picker.PickerBuilder()
      // @ts-ignore
      .enableFeature(google.picker.Feature.NAV_HIDDEN)
      // @ts-ignore
      .enableFeature(google.picker.Feature.MULTISELECT_ENABLED)
      .setDeveloperKey(GOOGLE_CONFIG.API_KEY)
      .setAppId(GOOGLE_CONFIG.APP_ID)
      .setOAuthToken(access_token)
      .addView(view)
      // // @ts-ignore
      // .addView(new google.picker.DocsUploadView())
      .setCallback(this.pickerCallback)
      .build();
    picker.setVisible(true);
  }

  public pickerCallback(data) {
    // @ts-ignore
    if (data.action === google.picker.Action.PICKED) {
      this.lstFileToLarge = [];
      data.docs.forEach(item => {
        this.totalLoadingFile++;
        if (this.isValidFileSize(item)) {
          if (this.uploadQueueFiles.map(file => file.id).includes(item.id)) {
            return;
          }
          // @ts-ignore
          gapi.client.drive.files
            .get({
              fileId: item.id,
              alt: 'media',
            })
            .then(async res => {
              const file = new File([new Blob([res.body])], item.name, {
                type: item.mimeType,
                lastModified: item.lastEditedUtc,
              });
              const obj = await this.convertToDocumentCard(file, 'Google Drive', item.id);
              this.totalLoadingFile--;
              this.uploadQueueFiles.push(obj);
              this.selectedItems.push(obj);
            });
        } else {
          this.lstFileToLarge.push(item.name);
        }
      });
      if (this.lstFileToLarge.length > 0) {
        this.noticeFileSizeToLarge();
      }
    }
  }

  beforeDestroy(): void {
    this.googleSignout();
  }

  public googleSignout() {
    access_token = null;
    // @ts-ignore
    google.accounts.oauth2.revoke(access_token);
  }

  selectAll() {
    if (this.selectedItems.length === this.uploadQueueFiles.length) this.selectedItems = [];
    else this.selectedItems = this.uploadQueueFiles;
  }

  setSelectedItems(newData) {
    this.selectedItems = newData;
    this.totalSelected = this.selectedItems.length;
  }

  deleteAll() {
    this.selectedItems = this.selectedItems.splice(0, 0);
  }
  async convertToDocumentCard(file, document, i) {
    const obj: any = {};
    obj.author = document + ' ' + Math.round((file.size / 1024 / 1024) * 100) / 100 + ' MB';
    obj.title = file.name;
    obj.description = Math.round((file.size / 1024 / 1024) * 100) / 100 + ' MB';
    obj.type = 'FILE';
    obj.originDate = file.lastModified;
    obj.images = [await this.detectFile(file.name)];
    obj.typeRemove = 'doc';
    obj.file = file;
    obj.id = i.toString();
    obj.checked = false;
    obj.document = document;
    obj.selected = true;
    return obj;
  }

  async detectFile(item) {
    let path = '/content/images/common/file/file.svg';
    const fileExtention = [
      { key: '.pdf', value: 'pdf' },
      { key: '.doc', value: 'word' },
      { key: '.docx', value: 'word' },
      { key: '.xls', value: 'excel' },
      { key: '.xlsx', value: 'excel' },
      { key: '.jpg', value: 'image' },
      { key: '.jpeg', value: 'image' },
      { key: '.png', value: 'image' },
      { key: '.txt', value: 'text' },
      { key: '.zip', value: 'zip' },
      { key: '.ppt', value: 'ppt' },
      { key: '.pptx', value: 'ppt' },
    ];
    let i = 0;
    while (i < fileExtention.length) {
      if (item.toLowerCase().endsWith(fileExtention[i].key)) {
        path = `/content/images/common/file/file-${fileExtention[i].value}-fill.svg`;
        break;
      }
      i++;
    }
    return await new Promise<string>((resolve, reject) => {
      $.get(path, function (data) {
        const s = new XMLSerializer().serializeToString(data.documentElement);
        const encodedData = 'data:image/svg+xml;base64,' + window.btoa(s);
        resolve(encodedData);
      }).fail(err => {
        reject(null);
      });
    });
  }

  removeCardReq(item) {
    const index = this.selectedItems.indexOf(item);
    if (index !== -1) this.selectedItems.splice(index, 1);
  }

  resetListSelected() {
    this.selectedItems.splice(0, this.selectedItems.length);
  }

  removeCardInList(item) {
    const index = this.uploadQueueFiles.indexOf(item);
    if (index !== -1) this.uploadQueueFiles.splice(index, 1);
    this.removeCardReq(item);
  }

  clearModalData() {
    this.uploadQueueFiles.splice(0, this?.uploadQueueFiles?.length);
    this.resetListSelected();
  }

  launchOneDrivePicker() {
    const that = this;
    const odOptions = {
      clientId: '20dc17e6-4673-457e-bd8f-f895e8be851f', //application id copied in step 4
      action: 'download',
      multiSelect: true,
      accountSwitchEnabled: false,
      success: function (files) {
        that.loadFile(files.value);
      }, //console.log(files) will give the short lived url of the file selected
      cancel: function () {
        console.log('cancel'); /* cancel handler */
      },
      error: function (error) {
        console.log('error'); /* error handler */
      },
    };

    OneDrive.open(odOptions);
  }

  loadFile(rawFiles) {
    const that = this;
    if (rawFiles?.length) {
      for (const rawFile of rawFiles) {
        if (!this.isValidFileSize(rawFile)) {
          this.lstFileToLarge.push(rawFiles.name);
          continue;
        }
        const request = new XMLHttpRequest();
        request.responseType = 'blob';
        request.open('GET', rawFile['@microsoft.graph.downloadUrl'], true);
        that.totalLoadingFile = that.totalLoadingFile + rawFiles.length;
        request.onload = function () {
          const reader = new FileReader();
          reader.readAsArrayBuffer(request.response);
          reader.onload = async function (e) {
            // @ts-ignore
            const bytes = new Uint8Array(e.target.result);
            const file = new File([bytes], rawFile.name);
            // console.log(file);
            const obj = await that.convertToDocumentCard(file, 'One Drive', rawFile.id);
            that.totalLoadingFile--;
            that.uploadQueueFiles.push(obj);
            that.selectedItems.push(obj);
          };

          reader.onerror = function () {
            that.totalLoadingFile--;
          };
        };
        request.onerror = function () {
          that.totalLoadingFile--;
        };
        request.send();
      }
      if (this.lstFileToLarge.length > 0) {
        this.noticeFileSizeToLarge();
      }
    }
  }
  addToReference() {
    this.$root.$emit('add-to-lst-reference', this.selectedItems);
    // @ts-ignore
    window.$('#modal-document-report').modal('hide');
  }

  nextAndPre(next?) {
    next
      ? $('#scroll-div-report-document').append($('#scroll-div-report-document').find('li:first-child'))
      : $('#scroll-div-report-document').append($('#scroll-div-report-document').find('li:last-child'));
  }

  created() {
    this.$root.$on('clear-modal-data-document', this.clearModalData);
  }

  destroyed() {
    this.$root.$off('clear-modal-data-document', this.clearModalData);
  }
}
